import React from 'react'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { streamingAgentRouteProps } from 'src/navigation/routeProps'
import StreamingAgentPage from 'src/page-components/StreamingAgentPage/StreamingAgentPage'

const StreamingAgentAppRoute: AppRoute = {
  id: AppLocation.StreamingAgent,
  routeProps: streamingAgentRouteProps,
  component: <StreamingAgentPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default StreamingAgentAppRoute
